export default "__VITE_ASSET__D$fj6DMS__"